<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_joueur">Joueurs</label>
      </div>
      <select id="sanction_joueur"
              v-model="dataForm.joueur_id"
              class="custom-select"
              name="sanction_joueur">
        <option :value="sanction.joueur_id">
          {{
          joueur ? (
              joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() + ' ' +
              joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() + ' ' +
              joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase()
          ) : 'Choisissez un joueur...'
          }}
        </option>
        <option :value="sanction.joueur_id">-------------------------------------</option>
        <option :key="joueur.joueur_id.slice(5,15)"
                :value="joueur.joueur_id"
                v-for="joueur in joueurs">
          {{ joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() }}
          {{ joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() }}
          {{ joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase() }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_carton_jaune">Carton jaune</label>
      </div>
      <input id="sanction_carton_jaune"
             v-model="dataForm.carton_jaune"
             class="form-control"
             name="sanction_carton_jaune"
             placeholder="Entrez le nombre de cartons jaune"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_carton_rouge">Carton rouge</label>
      </div>
      <input id="sanction_carton_rouge"
             v-model="dataForm.carton_rouge"
             class="form-control"
             name="sanction_carton_rouge"
             placeholder="Entrez le nombre de cartons rouge"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="sanction_match">Match</label>
      </div>
      <select id="sanction_match"
              v-model="dataForm.match_id"
              class="custom-select"
              name="sanction_match">
        <option :value="sanction.match_id">
          {{
            (equipes && match) ? (
                equipes.filter( (equipe) => equipe.equipe_id === match.equipe_a_id )[0].nom.toUpperCase() + ' vs ' +
                equipes.filter( (equipe) => equipe.equipe_id === match.equipe_b_id )[0].nom.toUpperCase() + ' (' +
                (new Date(match.date_rencontre).toLocaleDateString() + '-' + match.temps_rencontre) + ')'
            ) : 'Choisissez un match...'
          }}
        </option>
        <option :value="sanction.match_id">---------------------------------------------------</option>
        <option :key="match.match_id"
                :value="match.match_id"
                v-for="match in matchs">
          {{ (equipes && match) ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_a_id )[0].nom.toUpperCase() : '' }}
          vs
          {{ (equipes && match) ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_b_id )[0].nom.toUpperCase() : '' }}
          ({{ (match) ? (new Date(match.date_rencontre).toLocaleDateString() + '-' + match.temps_rencontre) : '' }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="sanction_raison">Causes de la sanction</label>
      </div>
      <textarea id="sanction_raison"
                v-model="dataForm.raison_sanction"
                class="form-control"
                name="sanction_raison"
                placeholder="Entrez un court commentaire sur les causes de la sanction"
                type="email">
      </textarea>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    sanction: {
      type: Object
    }
  },
  data() {
    return {
      joueurs: null,
      equipes: null,
      saisons: null,
      matchs: null,
      championnats: null,
      match: null,
      joueur: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        joueur_id: '',
        carton_jaune: '',
        carton_rouge: '',
        match_id: '',
        raison_sanction: '',
        table: 'sanctions',
        table_id: this.sanction.sanction_id,
      }
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
    ]),
    onSubmit() {
      this.axiosPutData(this.dataForm)
          .then((data) => {
            if(data.status === 204)
              this.messageSuccess = "Sanction modifiée avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de la modification de la sanction !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de la modification de la sanction !"
          })
    },
    resetDefaultValues() {
      if(this.dataForm.joueur_id === '')
        this.dataForm.joueur_id = this.sanction.joueur_id
      if(this.dataForm.carton_jaune === '')
        this.dataForm.carton_jaune = this.sanction.carton_jaune
      if(this.dataForm.carton_rouge === '')
        this.dataForm.carton_rouge = this.sanction.carton_rouge
      if(this.dataForm.match_id === '')
        this.dataForm.match_id = this.sanction.match_id
      if(this.dataForm.raison_sanction === '')
        this.dataForm.raison_sanction = this.sanction.raison_sanction
    },
    setDefaultValues() {
      const sanction = Object.assign({}, this.sanction);
      this.dataForm.joueur_id = sanction.joueur_id
      this.dataForm.carton_jaune = sanction.carton_jaune
      this.dataForm.carton_rouge = sanction.carton_rouge
      this.dataForm.match_id = sanction.match_id
      this.dataForm.raison_sanction = sanction.raison_sanction
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'joueurs'
    })
        .then((data) => {
          this.joueurs = data.data
          this.joueur = this.joueurs.filter((joueur) => joueur.joueur_id === this.sanction.joueur_id)[0]
        })
        .catch((data) => {
          this.joueurs = data
        })
    //
    this.axiosGetAllData({
      table: 'equipes'
    })
        .then((data) => {
          this.equipes = data.data
        })
        .catch((data) => {
          this.equipes = data
        })
    //
    this.axiosGetAllData({
      table: 'matchs_joues'
    })
        .then((data) => {
          this.matchs = data.data
          this.match = this.matchs.filter((match) => match.match_id === this.sanction.match_id)[0]
        })
        .catch((data) => {
          this.matchs = data
        })
    //
    this.axiosGetAllData({
      table: 'saisons'
    })
        .then((data) => {
          this.saisons = data.data
        })
        .catch((data) => {
          this.saisons = data
        })
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cartons/components/Update.vue